import {CountryCodeType, LanguageType} from 'model';

export type DemoLoginCountry = Extract<CountryCodeType, 'SE' | 'NO'>;

export const demoLoginCountries: Record<
  DemoLoginCountry,
  {label: string; scope: string; language: LanguageType}
> = {
  SE: {label: 'Sweden', scope: 'mypages-dids-SE', language: 'sv'},
  NO: {label: 'Norway', scope: 'mypages-dids-NO', language: 'nb'},
};

export const toDemoLoginCountry = (
  value: string | null | undefined,
): DemoLoginCountry => (value === 'NO' ? 'NO' : 'SE');
